<script>
// import DatePicker from "vue2-datepicker";

import OrdersApi from "@/services/orders-api";

export default {
  // components :{DatePicker},
  mounted(){

      var now = new Date();

      this.start = new Date(now.getFullYear(), 0, 1);
      const startoffset = this.start.getTimezoneOffset()
      this.start= new Date(this.start.getTime() - (startoffset*60*1000))
      this.start=this.start.toISOString().split('T')[0]

      this.end = now;
      const endoffset = this.end.getTimezoneOffset()
      this.end= new Date(this.end.getTime() - (endoffset*60*1000))
      this.end=this.end.toISOString().split('T')[0]

    this.getDiscounts()
  },
  data () {
    return {
    daterange:"",
    salesAnalyticsDonutChart : {
      chartOptions: {
          chart: {
              type: 'donut',
              height: 200,
          },
          labels: ['Remises', 'Gratuités'],
          colors: ['#34c38f', '#50a5f1'],
          legend: {
              show: false,
          },
          plotOptions: {
              pie: {
                  donut: {
                      size: '70%',
                  }
              }
          },
                  "yaxis": [{
          "labels": {
              "formatter": function (val) {
                  return val.toFixed(3)
              }
        }
    }]
      }
    },
    gratuityDiscount:0,
    nonGratuityDiscount:0,
    formattedGratuityDiscount:null,
    formattedNonGratuityDiscount:null,
    total:0,
    start:null,
    end:null,

    totalSales: null,
    avgDiscountAsStr: null,
    totalSalesBeforeDiscount: null,
    }
  },

  methods:{
    getDiscounts(){
      OrdersApi.getReportingDiscountGraph(this.start,this.end).then(

        (result)=>{
          if(result){
            this.gratuityDiscount=result.gratuityDiscount ===undefined || result.gratuityDiscount ===null  ? 0 : result.gratuityDiscount
            this.nonGratuityDiscount = result.nonGratuityDiscount ===undefined || result.nonGratuityDiscount ===null  ? 0 : result.nonGratuityDiscount
            this.formattedGratuityDiscount = result.formattedGratuityDiscount ===undefined || result.formattedGratuityDiscount ===null ? 0 : result.formattedGratuityDiscount
            this.formattedNonGratuityDiscount = result.formattedNonGratuityDiscount ===undefined || result.formattedNonGratuityDiscount ===null ? 0 : result.formattedNonGratuityDiscount
            this.total = result.totalDiscount ===undefined || result.totalDiscount ===null ? 0 : result.totalDiscount
            this.avgDiscountAsStr = result.avgDiscountAsStr ===undefined || result.avgDiscountAsStr ===null ? 0 : result.avgDiscountAsStr;

            this.totalSalesBeforeDiscount = result.totalSalesBeforeDiscountAsStr ===undefined || result.totalSalesBeforeDiscountAsStr ===null ? 0 : result.totalSalesBeforeDiscountAsStr

            
          }
          
        }
      );

      OrdersApi.getTotalSalesJson(this.start, this.end, false).then(
        (result)=>{
          if(result){
            this.totalSales=result;
            console.log(this.totalSales)
          }
        }
      )
    }
  },
    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getDiscounts()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getDiscounts()
          }
        }
    }
  
}
</script>
<template>
<div class="card  mt-sm-4 mt-xl-0 mt-lg-4 mt-md-4 h-100 border border-light " >
    <div class="card-body p-0" >
      <div class="clearfix m-4">
          <h4 class="card-title mb-2 font-size-18 text-primary">Remises par Période<span class="font-size-12 pl-1">(HT)</span></h4>
      </div>
      

    
    <div >

      <div class="row mr-2 ml-3 mt-0 text-center" >
          <div class="col-sm-6 col-xs-12 pr-2">
            <b-form-group  label-for="">
              <b-form-datepicker
                v-model="start"
                locale="fr"
                label-no-date-selected="Date Début"
                dark
                reset-button
                close-button
                label-reset-button="Réinitialiser"
                label-close-button="Fermer"
                dropright
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-sm-6 col-xs-12 pr-2">
            <b-form-group  label-for="">
              <b-form-datepicker
                v-model="end"
                locale="fr"
                label-no-date-selected="Date Fin"
                dark
                reset-button
                close-button
                label-reset-button="Réinitialiser"
                label-close-button="Fermer"
                dropright                         
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
            <!-- <label class="mr-2 text-secondary" >Filtrer par Dates</label> -->
            <!-- <date-picker v-model="daterange" placeholder="Date Début - Date Fin" range append-to-body lang="fr" style="max-width: 250px; " confirm></date-picker> -->
      </div>
      <div class="row mt-4 ">
        <div class="col-2"/>
        <div class="col-8 text-center">
          <p class="text-center font-size-20"> Vous avez bénéficié d'une somme de remise totale de : </p>
        </div>
        <div class="col-2"/>
      </div>
      <div class="row ">
        <div class="col-2"></div>
        <div class="col-8 text-center">
          <h3 class="text-success">{{this.total}} TND</h3>

        </div>
        <div class="col-2"></div>

      </div>
      <div>
        <apexchart
          class="apex-charts"
          height="200"
          :series="[nonGratuityDiscount,gratuityDiscount]"
          :options="salesAnalyticsDonutChart.chartOptions"
        ></apexchart>
      </div>
          <div class="text-center text-muted">
              <div class="row">
                <div class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-success mr-1"></i>
                      Total des Remises
                    </p>
                    <h5>{{this.formattedNonGratuityDiscount}} TND</h5>

                    <div v-if="totalSales && nonGratuityDiscount && totalSales.totalSales && totalSales.formattedTotalSales" class="row mt-3 mb-2">
                        <div class="col-12">
                          <p class="font-size-14 font-weight-bold mb-0 pb-0">Remise globale de <span class="font-weight-bold text-success"> {{ this.avgDiscountAsStr }} %</span></p>
                          <span>{{this.formattedNonGratuityDiscount}} TND / {{this.totalSalesBeforeDiscount}} TND</span>
                        </div>
                    </div>

                  </div>
                </div>
                <div class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-primary mr-1"></i>
                      Total des Gratuités
                    </p>
                    <h5>{{this.formattedGratuityDiscount}} TND</h5>
                  </div>
                </div>
              </div>         
      </div>

    </div>

    </div>
</div> 

</template>

